import { render, staticRenderFns } from "./DetailedPayslip.vue?vue&type=template&id=4084c900&scoped=true"
import script from "./DetailedPayslip.vue?vue&type=script&lang=js"
export * from "./DetailedPayslip.vue?vue&type=script&lang=js"
import style0 from "./DetailedPayslip.vue?vue&type=style&index=0&id=4084c900&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4084c900",
  null
  
)

export default component.exports